import Text, { TextProps } from "../../common/Text/Text";
import React from "react";
import clsx from "clsx";

const HeroTitle = (props: TextProps<"h1">) => {
	const { children, className, ...otherProps } = props;
	return (
		<Text
			{...otherProps}
			tag={"h1"}
			className={clsx("Hero__heading", className)}
		>
			{children}
		</Text>
	);
};

export default React.memo(HeroTitle);
